import { useEffect, useMemo, useState } from "react";
import { ClinicInfo } from "./ClinicInfo";
import { ClinicUsers } from "./ClinicUsers";
import { errorMessages } from "../../../../constants/errorMessages";
import { useGetClinicUserDetailsQuery } from "../../../../services/rtkQueryServices/clinicService";
import GettingStartedModal from "../../GettingStartedModal/GettingStartedModal";
import { useLocation, useNavigate } from "react-router-dom";
import { routePaths } from "../../../../constants/routePaths";

export function ClinicUserManagement(props: any) {
  const [refetchDetails, setRefetchDetails] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isBpSiteIdVerified, setIsBpSiteIdVerified] = useState<any>(null);
  const [isSubscriptionActive, setIsSubscriptionActive] = useState<any>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [navigatedFromRegistration, setNavigatedFromRegistration] =
    useState(false);
  const [isClinicLogoExists, setIsClinicLogoExists] = useState<any>(null);
  const [isLicencesAssigned, setIsLicencesAssigned] = useState<any>(null);

  useEffect(() => {
    // Check if user navigated from registration or login page
    const lastLocation = location.state?.from;
    if (
      lastLocation === routePaths.register ||
      lastLocation === routePaths.login
    ) {
      setNavigatedFromRegistration(true);
      // Clear the state after setting the variable
      navigate(location.pathname); // Reset location state
    } else {
      setNavigatedFromRegistration(false);
    }
  }, []);
  const {
    isFetching,
    isSuccess,
    isError,
    data: clinicUserDetails,
    refetch,
  } = useGetClinicUserDetailsQuery({});
  const clinicUserData = useMemo(() => {
    if (isSuccess && !isFetching) {
      setIsBpSiteIdVerified(clinicUserDetails?.data?.bpSiteId ? true : false);
      setIsSubscriptionActive(clinicUserDetails?.data?.isActive);
      if (!clinicUserDetails.data.clinicLogoUrl) {
        setIsClinicLogoExists(false);
      } else {
        setIsClinicLogoExists(true);
      }
      return clinicUserDetails?.data;
    }
  }, [clinicUserDetails]);
  useEffect(() => {
    if (refetchDetails) {
      refetch();
      setRefetchDetails(false);
    }
  }, [refetchDetails]);
  useEffect(() => {
    if (isError) {
      setErrorMessage(errorMessages.errorInfo);
    }
  }, [isError]);
  useEffect(() => {
    if (
      navigatedFromRegistration &&
      (isClinicLogoExists === false || isLicencesAssigned === false)
    ) {
      setOpenModal(true);
    } else if (
      navigatedFromRegistration &&
      isClinicLogoExists !== null &&
      isLicencesAssigned !== null
    ) {
      setNavigatedFromRegistration(false);
    }
  }, [isClinicLogoExists, isLicencesAssigned]);
  return (
    <>
      <div className="d-flex flex-column gap-4 px-3 h-100">
        <div>
          <ClinicInfo
            refetchClinicDetails={() => {
              setRefetchDetails(true);
            }}
            error={errorMessage}
            isBpSiteIdVerified={isBpSiteIdVerified}
            isSubscriptionActive={isSubscriptionActive}
            clinicUserData={clinicUserData}
          />
        </div>
        <div>
          <ClinicUsers
            refetchClinicDetails={() => {
              setRefetchDetails(true);
            }}
            isError={() => {
              setErrorMessage(errorMessages.errorInfo);
            }}
            isBpSiteIdVerified={isBpSiteIdVerified}
            isSubscriptionActive={isSubscriptionActive}
            isNoLicencesAssigned={(value: boolean) => {
              setIsLicencesAssigned(!value);
            }}
          />
        </div>
      </div>
      <GettingStartedModal
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
          setNavigatedFromRegistration(false);
        }}
      />
    </>
  );
}
